import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit", "counter", "emojiPicker", "emojiBtn"]

  connect() {
    // Initialize character counter
    this.updateCounter()
    
    // Close emoji picker when clicking outside
    this.closeEmojiOnClickOutside = this.closeEmojiOnClickOutside.bind(this)
    document.addEventListener('click', this.closeEmojiOnClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.closeEmojiOnClickOutside)
  }

  submit(event) {
    // Prevent submission if message is empty or only whitespace
    const content = this.inputTarget.value.trim()
    if (!content) {
      event.preventDefault()
      return
    }

    // Disable submit button to prevent double submissions
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.style.opacity = '0.6'
      this.submitTarget.style.cursor = 'not-allowed'
    }
  }

  clear(event) {
    // Clear the input field after successful submission
    if (event.detail.success !== false) {
      if (this.hasInputTarget) {
        this.inputTarget.value = ""
        this.inputTarget.style.height = '44px' // Reset height
        this.updateCounter()
      }
    }
    
    // Re-enable submit button
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.style.opacity = '1'
      this.submitTarget.style.cursor = 'pointer'
    }
  }

  adjustHeight(event) {
    const input = event.target
    input.style.height = '44px' // Reset to min height
    input.style.height = `${Math.min(input.scrollHeight, 120)}px` // Max 120px
    this.updateCounter()
  }

  handleEnter(event) {
    // Submit on Enter, new line on Shift+Enter
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      const content = this.inputTarget.value.trim()
      if (content) {
        this.element.requestSubmit()
      }
    }
  }

  updateCounter() {
    if (this.hasCounterTarget && this.hasInputTarget) {
      const length = this.inputTarget.value.length
      const maxLength = 5000
      this.counterTarget.textContent = `${length}/${maxLength}`
      
      // Update classes based on character count
      this.counterTarget.classList.remove('warning', 'danger')
      
      if (length > maxLength * 0.9) {
        this.counterTarget.classList.add('danger')
      } else if (length > maxLength * 0.7) {
        this.counterTarget.classList.add('warning')
      }
    }
  }

  toggleEmoji(event) {
    event.stopPropagation()
    if (this.hasEmojiPickerTarget) {
      this.emojiPickerTarget.classList.toggle('active')
    }
  }

  useStarter(event) {
    event.preventDefault()
    const text = event.currentTarget.dataset.starter
    if (!this.hasInputTarget || !text) return
    this.inputTarget.value = text
    this.inputTarget.focus()
    this.adjustHeight({ target: this.inputTarget })
    this.updateCounter()
  }

  insertEmoji(event) {
    event.stopPropagation()
    const emoji = event.currentTarget.dataset.emoji
    if (this.hasInputTarget && emoji) {
      const cursorPos = this.inputTarget.selectionStart
      const textBefore = this.inputTarget.value.substring(0, cursorPos)
      const textAfter = this.inputTarget.value.substring(cursorPos)
      
      this.inputTarget.value = textBefore + emoji + textAfter
      this.inputTarget.selectionStart = cursorPos + emoji.length
      this.inputTarget.selectionEnd = cursorPos + emoji.length
      this.inputTarget.focus()
      
      this.updateCounter()
      this.adjustHeight({ target: this.inputTarget })
    }
    
    // Close picker after inserting
    if (this.hasEmojiPickerTarget) {
      this.emojiPickerTarget.classList.remove('active')
    }
  }

  closeEmojiOnClickOutside(event) {
    if (this.hasEmojiPickerTarget && this.hasEmojiBtnTarget) {
      if (!this.emojiPickerTarget.contains(event.target) && 
          !this.emojiBtnTarget.contains(event.target)) {
        this.emojiPickerTarget.classList.remove('active')
      }
    }
  }
}

